module.exports = __webpack_public_path__ + "media/packs/src/webfonts/fa-solid-900-0f27e9b933cc50abbbba250c5f83aa12.woff2";